import styled from 'styled-components';

export const Content = styled.div`
  margin-bottom: 24px;
`;

export const ButtonGrid = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;

  button {
    max-width: 120px;
  }
`;

export const CheckboxItem = styled.li`
  display: flex;
  margin: -25px 0px 25px -15px;

  label {
    cursor: pointer;
    padding: 0 16px;
    color: ${({ theme }) => theme.colors.grey6};
  }
`;
